import React from "react";
import {
  Stack,
  Group,
  TextInput,
  Select,
  Button,
  Text,
  Checkbox,
  ActionIcon,
  SimpleGrid,
} from "@mantine/core";
import { IconPlus, IconTrash } from "@tabler/icons";
import { MCA_STEP_FIELD_TYPES } from "../../data/mcaEntities";
import { useMcaEditorReadOnly } from "./mcaEditorReadOnly";

const McaStepFieldsEditor = ({ stepFields = [], onChange }) => {
  const readOnly = useMcaEditorReadOnly();
  return (
  <Stack spacing="xs">
    <Text size="xs" color="dimmed">
      Define custom fields shown during this step (text, numbers, dates, file
      uploads, etc.).
    </Text>
    {stepFields.map((item, idx) => (
      <SimpleGrid
        key={idx}
        cols={5}
        spacing="sm"
        breakpoints={[
          { maxWidth: "lg", cols: 3 },
          { maxWidth: "sm", cols: 1 },
        ]}
        sx={{ alignItems: "flex-end" }}
      >
        <TextInput
          placeholder="Label (English)"
          size="xs"
          value={item.label ?? ""}
          readOnly={readOnly}
          onChange={(e) => {
            const next = stepFields.map((row, i) =>
              i === idx ? { ...row, label: e.target.value } : row
            );
            onChange(next);
          }}
        />
        <TextInput
          placeholder="Label (Chinese)"
          size="xs"
          value={item.cname ?? ""}
          readOnly={readOnly}
          onChange={(e) => {
            const next = stepFields.map((row, i) =>
              i === idx ? { ...row, cname: e.target.value } : row
            );
            onChange(next);
          }}
        />
        <Select
          placeholder="Type"
          size="xs"
          data={MCA_STEP_FIELD_TYPES}
          value={item.inputType ?? "TEXT"}
          readOnly={readOnly}
          onChange={(v) => {
            const next = stepFields.map((row, i) =>
              i === idx ? { ...row, inputType: v ?? "TEXT" } : row
            );
            onChange(next);
          }}
        />
        <Checkbox
          size="xs"
          label="Required"
          checked={!!item.required}
          disabled={readOnly}
          onChange={(e) => {
            const next = stepFields.map((row, i) =>
              i === idx ? { ...row, required: e.currentTarget.checked } : row
            );
            onChange(next);
          }}
        />
        {!readOnly && (
        <Group position="right" pb={4}>
          <ActionIcon
            variant="subtle"
            size="sm"
            onClick={() => onChange(stepFields.filter((_, i) => i !== idx))}
          >
            <IconTrash size={14} />
          </ActionIcon>
        </Group>
        )}
      </SimpleGrid>
    ))}
    {!readOnly && (
    <Button
      size="xs"
      w="fit-content"
      variant="light"
      leftIcon={<IconPlus size={14} />}
      onClick={() =>
        onChange([
          ...stepFields,
          { label: "", cname: "", inputType: "TEXT", required: false },
        ])
      }
    >
      Add input field
    </Button>
    )}
  </Stack>
  );
};

export default McaStepFieldsEditor;
